import { Injectable } from '@angular/core';
import { QueryNodePolicy, WorkflowLogicStepDef, WorkflowNode } from '../models';
import { LogicStepType, WorkflowType } from '@wdx/shared/utils';
import { WorkflowDesignerConfig } from '../models/workflow-designer-config';
import { v4 as uuidv4 } from 'uuid';

@Injectable({ providedIn: 'root' })
export class WorkflowQueryNodeHelper {
    private config: WorkflowDesignerConfig;

    public readonly queryStepDefinition: WorkflowLogicStepDef = {
        code: 'query',
        name: { key: 'WORKFLOW_DESIGNER_QUERY_NAME' },
        description: {
            key: 'WORKFLOW_DESIGNER_QUERY_DESCRIPTION',
        },
        icon: 'filter',
        type: 'Query' as LogicStepType,
    };

    public setConfig(config: WorkflowDesignerConfig) {
        this.config = config;
    }

    public applyInitialQueryNode(nodes: WorkflowNode[]): WorkflowNode[] {
        const workflowConfig = this.config.configuration;
        const policy = this.getQueryPolicy();
        const hasQuery = nodes.some((n) => n.nodeType === 'query');

        if ((workflowConfig.query || policy.required) && !hasQuery) {
            return [this.buildQueryNode(uuidv4()), ...nodes];
        }

        if (!policy.allowed && hasQuery) {
            return nodes.filter((n) => n.nodeType !== 'query');
        }

        return nodes;
    }

    public buildQueryNode(nodeId: string): WorkflowNode {
        const workflowConfig = this.config.configuration;
        const policy = this.getQueryPolicy();
        return {
            ...this.queryStepDefinition,
            nodeType: 'query',
            isValid: true,
            isRemovable: policy.removable,
            payload: {
                Id: nodeId,
                Code: 'query',
                query: workflowConfig?.query ?? {},
                queryDescription: workflowConfig?.queryDescription,
                exclusionPeriod: workflowConfig?.exclusionPeriod,
            },
            targetEntityType: this.config.targetEntityType,
        } as WorkflowNode;
    }

    public getQueryPolicy(): QueryNodePolicy {
        switch (this.config.type) {
            case WorkflowType.Adhoc:
                return { required: false, allowed: true, removable: true };
            case WorkflowType.Timed:
                return { required: true, allowed: true, removable: false };
            case WorkflowType.Triggered:
                return { required: false, allowed: false, removable: false };
        }
    }
}
